// 맨 위의 drag-tree.vue 구성 요소로 돌아 가기
const findRoot = which => {
  let ok = false
  let that = which
  while (!ok) {
    // 구성 요소 이름에 따라 根据组件name来判断
    if (that.$options._componentTag === 'drag-tree') {
      ok = true
      // 두 데이터 교환
      break
    }
    that = that.$parent
  }
  return that
}

/**
 * 두 노드가 포함되어 있는지 여부
 * 즉 : 아버지와 자식의 관계
 */
const hasInclude = (from, to) => {
  return from.$parent._uid === to._uid
}

/**
 * 두 노드가 선형 관계에 있음？
 * 즉, from은 to의 하위 집합이지만, 부모 - 자식 관계는 아닙니다. 即：from为to的某个子集，但又不是父子关系？
 */
const isLinealRelation = (from, to) => {
  let parent = from.$parent

  // 결과가 무엇이든간에 심판이 완료됩니다.
  let ok = false
  // 선형 관계인가？
  let status = false
  while (!ok) {
    if (parent._uid === to._uid) {
      ok = true
      status = true
      continue
    }
    if (!parent.$options._componentTag || parent.$options._componentTag === 'drag-tree') {
      // 이를 감지하면 끝났어야합니다.
      ok = true
      break
    }
    parent = parent.$parent
  }

  return status
}

/**
 * 두 노드의 데이터 교환
 * @param rootCom 루트 구성 요소（vue-drag-tree.vue）
 * @param from 끌어온 노드 구성 요소 Vnode 데이터
 * @param to 노드 구성 요소 Vnode 데이터 끌어 놓기
 */
const exchangeData = (rootCom, from, to) => {
  // 드래그 노드가 드래그 된 노드와 동일한 경우，return;
  if (from._uid === to._uid) {
    return
  }

  // 두 가지가 부모 - 자식 관계이고 from 하위노드, to 자식 노드 이면 아무것도하지 마라.
  if (hasInclude(to, from)) {
    return
  }

  const newFrom = Object.assign({}, from.model)

  // 두 사람이 아버지 - 아들 관계라면。将from 노드，이동위치 to노드 하나의 레벨과 하나의 레벨
  if (hasInclude(from, to)) {
    // "부모"가 최상위 노드 (노드 배열의 가장 바깥 쪽 데이터) 인 경우,
    const tempParent = to.$parent
    const toModel = to.model

    if (tempParent.$options._componentTag === 'drag-tree') {
      // 将from노드가 루트 배열에 추가되었습니다.
      tempParent.newData.push(newFrom)
      // 제거 移除to中from节点信息；
      toModel.children = toModel.children.filter(item => item.id !== newFrom.id)
      return
    }

    const toParentModel = tempParent.model
    // 先移除to中from节点信息；
    toModel.children = toModel.children.filter(item => item.id !== newFrom.id)
    // 将 from节点 添加到 to 一级别中。
    toParentModel.children = toParentModel.children.concat([newFrom])
    return
  }

  // 그것이 선형 관계이지만 아버지와 아들이 아닌 경우
  if (isLinealRelation(from, to)) {
    const fromParentModel = from.$parent.model
    const toModel = to.model

    // 先将from상위 노드 정보에서 제거됨；
    fromParentModel.children = fromParentModel.children.filter(item => item.id !== newFrom.id)

    // 再from추가 된 노드to노드의 마지막 비트。
    toModel.children = toModel.children.concat([newFrom])
    return
  }

  // 두 개의 노드（무선 관계），把from节点扔到to节点中。
  const fromParentModel = from.$parent.model
  const toModel = to.model
  // 先将from상위 노드 정보에서 제거됨；
  if (from.$parent.$options._componentTag === 'drag-tree') {
    /**
     * 找到vue-drag-tree的父组件（데이터 소스），여기에서 데이터 수정。
     */
    from.$parent.newData = from.$parent.newData.filter(item => item.id !== newFrom.id)
  } else {
    fromParentModel.children = fromParentModel.children.filter(item => item.id !== newFrom.id)
  }

  // 再from节点添加到to节点中最后一位。
  if (!toModel.children) {
    toModel.children = [newFrom]
  } else {
    toModel.children = toModel.children.concat([newFrom])
  }
}

export { findRoot, exchangeData }
